import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Terminal, Mail, ArrowLeft } from "lucide-react";

export default function ForgotPin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-pin", { email });
      setSent(true);
      toast.success("If that email is registered, a reset link was sent");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-fg" style={{ background: "var(--bg)" }}>
      <div className="max-w-md w-full" data-testid="forgot-pin-page">
        <Link to="/" className="flex items-center gap-2 mb-10">
          <Terminal size={18} className="text-amber"/>
          <div className="font-display text-xl text-amber">COYOTE/LIFE</div>
        </Link>
        <div className="label-xs text-amber">&gt; RESET_PIN</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-none mt-2">Forgot?</h1>
        <p className="mt-3 text-fg-muted font-mono text-sm">Enter your email. We&apos;ll send a link to reset your PIN.</p>

        {sent ? (
          <div className="mt-8 border border-term rounded p-6 bg-raised" data-testid="forgot-sent">
            <Mail size={24} className="text-electric mb-3" />
            <div className="font-display text-xl">Check your inbox.</div>
            <p className="text-sm text-fg-muted mt-2 font-mono">If an account exists for <span className="text-fg">{email}</span>, a reset link is on its way. Link expires in 30 minutes.</p>
            <button onClick={() => navigate("/login")} className="btn-secondary mt-6 w-full">Back to Login &gt;</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="label-xs mb-1 block">Email</label>
              <input type="email" className="input-term" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
            </div>
            <button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="btn-primary w-full">
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <Link to="/login" className="btn-ghost w-full flex items-center justify-center"><ArrowLeft size={14} /> Back</Link>
          </form>
        )}
      </div>
    </div>
  );
}
